// extracted by mini-css-extract-plugin
export var actionButton = "_i8-0";
export var actionMenuContainer = "_i8-i";
export var bubble = "_i8-2";
export var bubbleActionMenu = "_i8-j";
export var bubbleContext = "_i8-6";
export var bubbleItems = "_i8-7";
export var customer = "_i8-3";
export var divider = "_i8-8";
export var fileList = "_i8-9";
export var hiddenComment = "_i8-o";
export var infoAbove = "_i8-a";
export var internal = "_i8-4";
export var lightActionButton = "_i8-1";
export var link = "_i8-b";
export var merchant = "_i8-5";
export var message = "_i8-c";
export var profilePicture = "_i8-e";
export var quillToolbarContainer = "_i8-f";
export var senderDate = "_i8-g";
export var senderDateCustomer = "_i8-h";
export var senderName = "_i8-d";
export var time = "_i8-k";
export var uploadedImage = "_i8-l";
export var username = "_i8-m";
export var xsmall = "_i8-n";